var DEFAULT_DELAY_OPEN = 200;
var DEFAULT_DELAY_CLOSE = 300;
var sizeOptions = ['small', 'medium', 'large', 'x-large'];

export { DEFAULT_DELAY_CLOSE, DEFAULT_DELAY_OPEN, sizeOptions };
//# sourceMappingURL=constants.js.map
